import Vue from 'vue';
import Router from 'vue-router';

import Cart from './views/Cart.vue';
import Checkout from './views/Checkout.vue';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'cart',
            component: Cart,
        },
        {
            path: '/checkout/:step',
            name: 'checkout',
            component: Checkout,
        },
    ],
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        };
    },
});
